import { useMediaQuery } from '@react-hook/media-query';
import { theme } from 'src/styles';

export const useIsMobile = (): boolean =>
  useMediaQuery(`(max-width: ${theme.breakpoints.siteBreakpoint}px)`);

export default useIsMobile;
